/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { Theme, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import React from "react";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => createStyles({
  header: {
    textDecoration: "none",
    color: "inherit",
    padding: theme.spacing(1,2),
    verticalAlign: "bottom",
  },
  drawer: {
    flex: 1,
    textDecoration: "none",
    color: "inherit",
    padding: theme.spacing(1, 2),
    verticalAlign: "middle",
    height: "40px",
  },
  activeLink: {
    backgroundColor: theme.palette.primary.light,
  },
  linkText: (props: NavLinkProps) => ({
    height: "100%",
    verticalAlign: props.orientation === "drawer" ? "middle" : "bottom",
    color: theme.palette.getContrastText(theme.palette.primary.main),
  }),
})

);

interface NavLinkProps {
  children: string;
  path: string;
  isActive: boolean;
  orientation: "header" | "drawer";
}

const NavLink = (props: NavLinkProps) => {
  const classes = useStyles(props);

  return (
    <Link className={[
      props.orientation === "header"
        ? classes.header
        : classes.drawer
      , props.isActive
        ? classes.activeLink
        : ""
    ].join(" ")} to={props.path}>
      <Typography className={classes.linkText} variant="body1" color="inherit">
        {props.children}
      </Typography>
    </Link>
  );
};

export default NavLink;
